export default __webpack_public_path__ + "static/media/31M.31349c95.jpeg";